import React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'

import "./Cards.css";

const Cards = ({home}) => {

  const icons = [faMapMarkerAlt, faPhone, faEnvelope];

  const cards = home;
  let matrix = [];
  let el = 0;
  let cols = 3;
  let rows = cards.length / cols;
  for (let i = 0; i < rows; i++) {
    let arr = [];
    for (let j = 0; j < cols; j++, el++) {
      arr[j] = cards[el];
    }
    matrix.push(arr);
  }

  return (
    <div className="card-deck mx-0">
      {matrix.map(arr => (
        
        <div key={matrix.indexOf(arr)} className="row row-cols-1 mx-0 row-cols-md-3" data-aos="fade-up" data-aos-easing data-aos-duration="1000" data-aos-once="true">
          {arr.map(item => {

            const { heading, image, link, description, icon } = item;

            return (
              <div key={arr.indexOf(item)} className="p-0 p-sm-2">
                <article className={`card h-100 ${(image === false) ? "rounded-sm" : "border-0"} mx-0 `}>
                  {(image === false) 
                    ? 
                    <div className="Cards-image-screen card-img-top d-flex justify-content-center"><FontAwesomeIcon className={`icon display-3 align-self-center ${(icon === 0) ? "text-danger" : "text-muted"}`} icon={icons[icon]} /></div>
                    : 
                    <figure className={`Cards-image shadow ${image}`}><div className="Cards-image-screen card-img-top"/></figure>
                  }
                  <div className="card-body">
                    <p className="card-title lead text-uppercase font-weight-bold">
                      {(link === false) ? heading : <Link to={`/${link}`} className="card-link stretched-link">{heading}</Link>}
                    </p>
                    {(description === false) 
                      ? 
                      "" 
                      : 
                      <div>{description.map(el => (
                        <span key={description.indexOf(el)}>
                          {(el === "info@accincnyc.com") ? <a href='mailto:info@accincnyc.com'>{el}</a> : el}<br />
                        </span>
                      ))}</div>
                    }
                  </div>
                </article>
              </div>
            )                
          })}
        </div>

      ))}

    </div>
  );  
  
}

export default Cards;
